module.exports = __webpack_public_path__ + "img/quotes-3.7633e7d8.png";